import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ItemFormFilling } from '../../Filling/Types';
import Stack from '@mui/material/Stack';
import { Divider, Typography } from '@material-ui/core';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CheckIconItemComp from '../CheckIconItemComp';
import { useContext, useEffect } from 'react';
import { NewWebFormContext } from '../../../context/NewWebFormContext';


export default function DrawerList({
  itens,
  setOpen,
  setItemToShow,
}: {
  itens: ItemFormFilling[]
  setOpen: Function
  setItemToShow: Function,
}) {
  const { ForceUpdate } = useContext(NewWebFormContext);

  useEffect(() => {
    ForceUpdate()
  }, [])

  return (
    <Box sx={{ width: 300, paddingLeft: '10px' }} role="presentation" onClick={() => setOpen(false)}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginRight: '10px' }}
      >
        <Typography style={{ marginTop: '5px' }} variant='h6'>Itens:</Typography><ArrowBackIosNewIcon />
      </Stack>
      <List>
        {itens.map((item, index) => (
          <>
            <ListItem key={index} disablePadding onClick={() => {setItemToShow(index); window.scrollTo(0, 0)}}>
              <ListItemButton>
                <Stack
                  width={'100%'}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <ListItemText primary={item.nome} />
                  <ListItemIcon>
                    <CheckIconItemComp item={item} />
                  </ListItemIcon>
                </Stack>
              </ListItemButton>
            </ListItem>
            <Divider />
          </>
        ))}
      </List>
    </Box>
  );
}
